module.exports = __webpack_public_path__ + "img/3.ff68f11a.jpg";